import { isString } from 'lodash';
import { SubmissionError } from 'redux-form/immutable';
import { resetPassword } from '../../../services/API';

export default async function (vals) {
  const values = vals.toJS();
  validate(values);

  const data = await resetPassword(values);
  return validateResponse(data);
}

async function validateResponse(response) {
  if (!response.isOk) {
    const error = response.error.response.data;
    if (isString(error)) {
      throw new SubmissionError({
        _error: error,
      });
    } else {
      throw new SubmissionError(error);
    }
  }
}

function validate(values) {
  const requiredMessage = 'Это поле не может быть пустым';
  const error = {};

  if (!values.inn) {
    error.inn = requiredMessage;
  }

  if (!values.email) {
    error.email = requiredMessage;
  }

  if (!values.codeWord) {
    error.codeWord = requiredMessage;
  }

  if (Object.keys(error).length > 0) {
    throw new SubmissionError(error);
  }
}
